export default __webpack_public_path__ + "static/media/askBricall.f74b6437.png";